<template>
  <div id="app">
    <!-- 头部 -->
    <home-header></home-header>

    <iframe
      id="iframe"
      class="iframe"
      src="MMS3D/mms3D/index1.html"
      frameborder="0"
    ></iframe>

    <!-- 天气变化按钮 -->
    <div
      class="icon-button"
      :class="{ active: change == 1 }"
      @click="weaterChange"
    ></div>
    <div
      class="back"
      :class="{ backActive: backChange == 1 }"
      @click="back"
      v-show="backShow"
    ></div>
    <!-- 天气变化框 -->
    <div class="control-top" v-show="showValue">
      <div class="control-left">
        <span class="text">涨水:</span>
        <div class="scale">
          <span>5m</span>
          <div class="scale-img"></div>
          <el-slider
            v-model="value"
            vertical
            @input="bpp(value)"
            height="165px"
            class="slider-river"
          >
          </el-slider>
        </div>
      </div>
      <div class="control-right">
        <span class="qie">天气切换:</span>
        <div class="weater-off">
          <div class="sun-rain">
            <div class="sun-icon"></div>
            <span class="text">晴天</span>
            <div
              class="off"
              @click="weaterBtn(1)"
              :class="{ active1: change1 == 1 }"
            ></div>
          </div>
          <div class="slash">/</div>
          <div class="sun-rain">
            <div class="rain-icon"></div>
            <span class="text">雨天</span>
            <div
              class="off"
              @click="weaterBtn(2)"
              :class="{ active1: change1 == 2 }"
            ></div>
          </div>
        </div>
        <span class="linshitext">雨量传感器</span>
        <div class="bottom-control">
          <!-- <div class="linshi">
              </div> -->
          <div class="Hrainfall">
            <span>强降雨</span>
            <div
              class="of"
              @click="rainSensor(1)"
              :class="{ active2: change2 == 1 }"
            ></div>
          </div>
          <div class="rainfall">
            <span>降雨</span>
            <div
              class="of"
              @click="rainSensor(2)"
              :class="{ active2: change2 == 2 }"
            ></div>
          </div>
          <div class="sunny">
            <span>晴天</span>
            <div
              class="of"
              @click="rainSensor(3)"
              :class="{ active2: change2 == 3 }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部控件 -->
    <div class="bottom-contral" v-show="bottomContral">
      <div
        class="monitoring-system"
        @click="monitoring()"
        :class="{ monitoringActive: monitoringChange == 1 }"
      >
        <div>监控系统</div>
      </div>
      <div
        class="Rainfall-equipment"
        @click="cklect()"
        :class="{ RainfallActive: RainfallChange == 1 }"
      >
        <div>遥测设备</div>
      </div>
      <div
        class="Telemetry-control"
        @click="spctd()"
        :class="{ TelemetryActive: telemetryChange == 1 }"
      >
        <div>遥测控制</div>
      </div>
      <div
        class="Fire-system"
        @click="fire()"
        :class="{ fireActive: fireChange == 1 }"
      >
        <div>消防系统</div>
      </div>
      <div class="bottombg"></div>
    </div>
    <div class="flsh-contral" v-show="flshShow">
      <div class="ttttt">
        <div class="enter" @click="enter()">
          <span>回车</span><img src="./assets/img/45444.png" alt="" />
        </div>
        <div class="rise" @click="rise()">
          <span>上升</span><img src="./assets/img/555.png" alt="" />
        </div>
        <div class="go" @click="go()">
          <span>出车</span><img src="./assets/img/666.png" alt="" />
        </div>
        <div class="decline" @click="decline()">
          <span>下降</span><img src="./assets/img/777.png" alt="" />
        </div>
      </div>
    </div>

    <div class="guide" v-show="ct">
      <div class="ads" @click="telemetry()" :class="spct == 1 ? 'push' : ''">
        揽道测流
      </div>
      <div class="ads" @click="wave()" :class="spct == 0 ? 'push' : ''">
        雷达波测流
      </div>
    </div>
    <div class="guidea" v-show="show">
      <div
        class="ads"
        v-for="(item, index) in app"
        :key="index"
        @click="cter(index)"
        :class="ctec == index ? 'push' : ''"
      >
        {{ item }}
      </div>
    </div>

    <div class="telemetryVideoShow" v-show="video1Show">
      <videoT :m3u8url="this.video1"></videoT>
    </div>
    <div class="waveVideoShow" v-show="video2Show">
      <videoT :m3u8url="this.video2"></videoT>
    </div>
    <router-view />
  </div>
</template>

<script>
import HomeHeader from "./components/HomeHeader.vue";
import videoT from "./components/videoT"; // 右下角 监控组件
import "videojs-contrib-hls"; // hls  视频流

export default {
  name: "App",
  components: {
    HomeHeader,
    videoT
  },
  data() {
    return {
      num: 1,
      change: -1,
      change1: 0,
      change2: 0,
      value: 0,
      showValue: false,
      flshShow: 0,
      telemetryChange: 0,
      bottomContral: 1,
      backChange: 0,
      backShow: 0, //返回
      monitoringChange: 0,
      RainfallChange: 0,
      fireChange: 0,
      list: "",
      spct: -1, //判断样式
      ct: false, //两按钮显示
      app: ["蒸发器", "传感器", "铅鱼信息", "气泡水位计", "数字水位计"],
      ctec: -1,
      show: false, //六按钮显示
      recs: true,
      numd: 0,
      currentIndex: null,
      video1:'http://220.161.87.62:8800/hls/0/index.m3u8', //揽道测流
      video2:"http://cctvalih5ca.v.myalicdn.com/live/cctv2_2/index.m3u8", //雷达波测流
      video1Show:false,
      video2Show:false
    };
  },
  mounted() {
    window.addEventListener("message", (val) => {
      if (val.data.type == "3dok") {
        this.list = val.data.type;
      }

      if (val.data.type == "true") {
        this.jurhv = true;
      }
    });
  },
  methods: {
    // 遥测设备
    cklect() {
      this.show = !this.show;
      this.RainfallChange = !this.RainfallChange;
      if (this.RainfallChange == 1) {
        this.ctec = -1;
        this.ct = false;
      } else {
        this.RainfallChange = 0;
      }
      this.telemetryChange = 0;
    },
    //
    cter(index) {
      this.ctec = index;
      if (this.currentIndex == index) {
        document.getElementById("iframe").contentWindow.poes();
        this.jurhv = false;
        this.currentIndex = 100;
        return;
      }
      if (index == 2) {
        this.show = false;
      }
      this.currentIndex = index;
      document.getElementById("iframe").contentWindow.index(index);
      this.jurhv = true;
    },
    // 雷达波测流
    wave() {
      this.video2Show = !this.video2Show;
      this.spct = 0;
      document.getElementById("iframe").contentWindow.wave(true);
    },
    // 遥测 控制
    spctd() {
      this.telemetryChange = !this.telemetryChange;
      if (this.telemetryChange == 1) {
        this.ct = !this.ct;
        this.spct = -1;
        this.show = false;
      } else {
        this.telemetryChange = 0;
        this.spct = 1;
        this.ct = false;
      }
      this.RainfallChange = 0;
    },
    monitoring() {
      this.monitoringChange = !this.monitoringChange;
      if (this.num == 1) {
        document.getElementById("iframe").contentWindow.app(1);
        this.num = 0;
      } else if (this.num == 0) {
        document.getElementById("iframe").contentWindow.app(0);
        this.num = 1;
      }
    },
    bpp(E) {
      console.log(E);
      if (this.list == "3dok") {
        document.getElementById("iframe").contentWindow.river(E * 0.6);
      }
    },

    weaterChange() {
      console.log(1);
      this.showValue = !this.showValue;
      if (this.showValue == true) {
        this.change = 1;
        console.log(1);
      } else {
        this.change = 0;
        console.log(0);
      }
      this.change1 = 0;
      // console.log('1')
      //  document.getElementById('iframe').contentWindow.addLight('10');
    },
    back() {
      this.backChange = !this.backChange;
      this.video1Show = false;
      if (this.backChange == 1) {
        this.ct = true;
        console.log(123);
        this.telemetryChange == 0;
        this.flshShow = 0;
        this.bottomContral = 1;
        this.$store.state.showContent = true;
      }
      this.backChange = 0;
      this.backShow = 0;
      document.getElementById("iframe").contentWindow.bact();
    },
    weaterBtn(val) {
      let date = new Date();
      if (val === 1) {
        this.change1 = 1;
        document
          .getElementById("iframe")
          .contentWindow.c(date.getHours(), "fine");
        document.getElementById("iframe").contentWindow.m(0);
      } else {
        this.change1 = 2;
        document
          .getElementById("iframe")
          .contentWindow.weater(date.getHours(), "rain");
        document.getElementById("iframe").contentWindow.m(1);
      }
    },
    rainSensor(val) {
      if (val === 1) {
        this.change2 = 1;
        document.getElementById("iframe").contentWindow.hydrops(3, "rain", 1);
      } else if (val === 2) {
        this.change2 = 2;
        document
          .getElementById("iframe")
          .contentWindow.hydrops(2, "rainstorm", 1);
      } else if (val === 3) {
        this.change2 = 3;
        document.getElementById("iframe").contentWindow.hydrops(1, "fine", 0);
      }
    },
    // 遥测
    telemetry() {
      //  this.telemetryChange = 0; //判断是否点击事件
      this.video1Show = true;
      this.ct = false;
      this.flshShow = 1; //铅鱼控制
      this.bottomContral = 0; //底控面板消失
      this.$store.state.showContent = false; //控制两侧面板
      this.backChange == 0;
      document.getElementById("iframe").contentWindow.fishlead(0);
      this.backShow = 1; //返回按钮控制
    },
    fire() {
      this.fireChange = !this.fireChange;
    },
    enter() {
      document.getElementById("iframe").contentWindow.fishlead(4);
    },
    rise() {
      document.getElementById("iframe").contentWindow.fishlead(3);
    },
    go() {
      document.getElementById("iframe").contentWindow.fishlead(1);
    },
    decline() {
      document.getElementById("iframe").contentWindow.fishlead(2);
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  width: 100vw;
  overflow: hidden;
  height: 100%;
  /*background: #000;*/
  color: #fbfcfc;
}

html,
body {
  width: 100%;
  height: 100%;
  /*width:8160px;*/
  /*height:1890px;*/
  margin: 0;
  padding: 0;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

i {
  font-style: normal;
}
.iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.iframe {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.icon-button {
  width: 2.6vw;
  height: 4.9vh;
  position: absolute;
  top: 3.2vw;
  left: 20vw;
  background: url("./assets/img/button1.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.active {
  background: url("./assets/img/button2.png") no-repeat;
  background-size: 100% 100%;
}

.control-top {
  width: 18vw;
  height: 21vh;
  background: url("./assets/img/controlbg.png");
  position: absolute;
  top: 4vw;
  left: 23vw;
}

.control-left {
  width: 6.6vw;
  height: 100%;

  float: left;
}
.control-left > .text {
  margin-left: 1.5vw;
  margin-top: 1vh;
  font-size: 0.6vw;
  float: left;
}
.scale {
  width: 100%;
  height: 17.8vh;
}
.scale span {
  position: absolute;
  left: 2.18vw;
  top: 10vh;
  font-size: 0.6vw;
  color: #04ecf6;
}

.scale-img {
  width: 0.26vw;
  height: 16.8vh;
  background: url("./assets/img/scale.png");

  background-size: 100% 100%;
  position: absolute;
  left: 3.1vw;
  top: 2.5vh;
}
.input-scale {
  position: absolute;
  left: 3.7vw;
  top: 2.5vh;
}
.slider-river {
  margin: 2.5vh 0 0 3.2vw;
}

.control-right {
  width: 11.4vw;
  height: 100%;
  float: left;
}
.control-right .qie {
  width: 100%;
  font-size: 0.6vw;
  color: #f3f4f6;
  margin-top: 1.3vh;
  float: left;
}
.weater-off {
  width: 10.2vw;
  height: 3.1vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.weater-off:hover {
  background: url("./assets/img/sun-rain.png");
  background-size: 100% 100%;
}
.slash {
  width: 0.5vw;
  height: 100%;
  text-align: center;
  line-height: 3.1vh;
}

.sun-rain {
  width: 4.5vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.sun-rain .text {
  height: 3.1vh;
  font-size: 12px;
  line-height: 3.1vh;
}
.sun-rain .text {
  height: 3.1vh;
  font-size: 12px;
  line-height: 3.1vh;
}

.sun-icon {
  width: 0.98vw;
  height: 1.86vh;
  background: url("./assets/img/sun.png");
  background-size: 100% 100%;
}
.rain-icon {
  width: 0.98vw;
  height: 1.86vh;
  background: url("./assets/img/rain1.png");
  background-size: 100% 100%;
}
.off {
  width: 0.83vw;
  height: 1.48vh;
  background: url("./assets/img/off.png");
  background-size: 100% 100%;
  cursor: pointer;
}

.active1 {
  background: url("./assets/img/on.png");
  background-size: 100% 100%;
}

.linshitext {
  font-size: 0.6vw;
  color: #f3f4f6;
  margin-top: 1.3vh;
  float: left;
}
.bottom-control {
  width: 10.3vw;
  height: 11.2vh;
  float: left;
}
.Hrainfall {
  width: 100%;
  height: 2.84vh;
  background: url("./assets/img/Hrainfall.png") no-repeat 0.26vw 0.78vh / 0.78vw
    1.56vh;
  border-bottom: 1px dashed #657f93;
  float: left;
}

.rainfall {
  width: 100%;
  height: 2.84vh;
  margin-top: 0.8vh;
  background: url("./assets/img/rain.png") no-repeat 0.26vw 0.78vh / 0.78vw
    1.56vh;
  border-bottom: 1px dashed #657f93;
  float: left;
}
.sunny {
  width: 100%;
  height: 2.84vh;
  margin-top: 0.8vh;
  background: url("./assets/img/sun.png") no-repeat 0.26vw 0.78vh / 0.78vw
    1.56vh;
  border-bottom: 1px dashed #657f93;
  float: left;
}
.Hrainfall span {
  height: 100%;
  width: 2.6vw;
  font-size: 0.6vw;
  color: #bae7ff;
  margin-left: 1.3vw;
  line-height: 2.9vh;
  float: left;
}
.rainfall span {
  height: 100%;
  width: 2.6vw;
  font-size: 0.6vw;
  color: #bae7ff;
  margin-left: 1.3vw;
  line-height: 2.9vh;
  float: left;
}

.sunny span {
  height: 100%;
  width: 2.6vw;
  font-size: 0.6vw;
  color: #bae7ff;
  margin-left: 1.3vw;
  line-height: 2.9vh;
  float: left;
}

.bottom-control .of {
  width: 0.83vw;
  height: 1.7vh;
  margin-left: 9vw;
  margin-top: 0.77vh;
  background: url("./assets/img/off.png") no-repeat;
  cursor: pointer;
}

.active2 {
  width: 0.86vw;
  height: 1.56vh;
  margin-left: 9vw;
  margin-top: 0.77vh;
  background: url("./assets/img/on.png") no-repeat !important;
}

.back {
  width: 2.6vw;
  height: 4.9vh;
  position: absolute;
  top: 6vw;
  left: 20vw;
  background: url("./assets/img/back.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.backActive {
  background: url("./assets/img/back1.png") no-repeat;
  background-size: 100% 100%;
}

.bottom-contral {
  width: 41.6vw;
  height: 9.4vh;
  position: absolute;
  bottom: 0;
  left: 29vw;
}
.ttttt {
  max-width: 11vw;
  height: 21vh;
  background: url("./assets/img/flsh1.png");
  background-size: 100% 100%;
  border-radius: 5.5vw;
  margin-left: 33.5vw;
  margin-top: 1vh;
  position: relative;
}

.enter {
  position: absolute;
  top: 3.8vh;
  left: 0.5vw;
}
.enter span {
  position: absolute;
  font-size: 0.6vw;
  top: 5.8vh;
  left: 0.5vw;
}
.rise {
  position: absolute;
  left: 2.2vw;
  top: 0.68vh;
}
.rise span {
  position: absolute;
  font-size: 0.6vw;
  left: 2.6vw;
  top: 1.5vh;
}

.go {
  position: absolute;
  left: 7.55vw;
  top: 3.8vh;
}

.go span {
  position: absolute;
  font-size: 0.6vw;
  left: 1.2vw;
  top: 5.8vh;
}

.decline {
  position: absolute;
  left: 2.1vw;
  top: 14.5vh;
}

.decline span {
  position: absolute;
  font-size: 0.6vw;
  left: 2.6vw;
  top: 2.8vh;
}

.enter img,
.rise img,
.go img,
.decline img {
  max-width: 88%;
  max-height: 88%;
}

.bottombg {
  width: 41.6vw;
  height: 3vh;
  background: url("./assets/img/bottombg1.png") no-repeat;
  position: absolute;
  bottom: 0;
}

.monitoring-system {
  width: 3.1vw;
  height: 5.92vh;
  background: url("./assets/img/monitor-control.png") no-repeat top/3vw 4.35vh;
  position: absolute;
  left: 7.2vw;
  cursor: pointer;
  top: 0.83vh;
}
.monitoringActive {
  background: url("./assets/img/monitor-control1.png") no-repeat top/3vw 4.35vh;
}
.Telemetry-control {
  width: 3.1vw;
  height: 5.92vh;
  background: url("./assets/img/telemetering.png") no-repeat top/3vw 4.35vh;
  position: absolute;
  left: 23.5vw;
  cursor: pointer;
}
.TelemetryActive {
  background: url("./assets/img/telemetering1.png") no-repeat top/3vw 4.35vh;
}

.Rainfall-equipment {
  width: 3.1vw;
  height: 5.92vh;
  background: url("./assets/img/rainFall.png") no-repeat top/3vw 4.35vh;
  position: absolute;
  left: 15.5vw;
  cursor: pointer;
}
.RainfallActive {
  background: url("./assets/img/rainFall1.png") no-repeat top/3vw 4.35vh;
}

.Fire-system {
  width: 3.1vw;
  height: 5.92vh;
  background: url("./assets/img/fire.png") no-repeat top/3vw 4.35vh;
  position: absolute;
  left: 32vw;
  top: 0.83vh;
  cursor: pointer;
}

.fireActive {
  background: url("./assets/img/fire1.png") no-repeat top/3vw 4.35vh;
}

.monitoring-system div,
.Rainfall-equipment div,
.Telemetry-control div,
.Fire-system div {
  width: 100%;
  height: 1.2vh;
  font-size: 0.6vw;
  position: absolute;
  left: 0.2vw;
  top: 4.4vh;
}

.flsh-contral {
  width: 52.65vw;
  height: 22.9vh;
  position: absolute;
  bottom: 2vh;
  background: url("./assets/img/flsh-contral.png");
  background-size: 100% 100%;
  left: 23.75vw;
}

#app:after {
  content: "";
  position: absolute;
  bottom: 0.5%;
  left: 1%;
  width: 98%;
  height: 10px;
  /* background: url("./assets/bottom.png") no-repeat; */
  background-size: 100%;
}

@font-face {
  font-family: SOURCEHANSANSCN-REGULAR;
  src: url("./assets/font/SOURCEHANSANSCN-REGULAR.OTF");
}
@font-face {
  font-family: pangmenzhengdao;
  src: url("./assets/font/庞门正道标题体2.0增强版.TTF");
}
.guide {
  width: 6%;
  height: 10%;
  z-index: 10;
  position: absolute;
  left: 51%;
  bottom: 10%;
  background-color: rgba(48, 66, 86, 0.8);
}
.guide div {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e8e8e8;
}
.guide > div:first-child {
  letter-spacing: 4.5px;
}
.ads {
  cursor: pointer;
}
.ads:hover {
  color: #04ecf6;
  background-color: rgba(36, 91, 105, 1);
}
.push {
  color: #04ecf6;
  background-color: rgba(36, 91, 105, 1);
}
.guidea {
  width: 6%;
  height: 14%;
  z-index: 10;
  position: absolute;
  left: 43%;
  bottom: 10%;
  background-color: rgba(48, 66, 86, 0.8);
}
.guidea div {
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e8e8e8;
  font-size: 14px;
}
.guidea div:first-child {
  letter-spacing: 10px;
  text-align: center;
  /* margin-left: 0.5vw; */
}
.guidea div:nth-child(2) {
  letter-spacing: 10px;
}
.guidea div:nth-child(3) {
  letter-spacing: 5px;
}
.guidea div:nth-child(4) {
  letter-spacing: 1px;
}
.guidea div:last-child {
  letter-spacing: 1px;
}

.telemetryVideoShow {
 width:22vw;
  height: 25vh;
  position: absolute;
  right: 3vw;
  top: 13vh;
  background: url('./assets/img/monitor-tkbg.png') no-repeat;
  background-size:100% 100% ;
}
.waveVideoShow {
  width:22vw;
  height: 25vh;
  position: absolute;
  left: 23vw;
  top: 7vh;
  background: url('./assets/img/monitor-tkbg.png') no-repeat;
  background-size:100% 100% ;
}
</style>
